// import node module libraries
import { Button, Card, Form } from 'react-bootstrap';
// import custom components
import { useEffect, useState } from 'react';
// import services
import SalledeclasseService from '../../../services/SalledeclasseService';

const EditOldInfoScolaires = (props) => {
	const { previous, initialValues } = props;

	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [classeOptions, setClasseOptions] = useState([]);
	const [formValues, setFormValues] = useState({
		...initialValues,
		is_new_student: !!initialValues.ancienne_ecole,
		bulletin_notes_annee_precedente:
			initialValues.bulletin_notes_annee_precedente
				? {
						file: initialValues.bulletin_notes_annee_precedente.file,
						fileURL: initialValues.bulletin_notes_annee_precedente.fileURL
				  }
				: null
	});

	const [selectedStatut, setSelectedStatut] = useState('');
	const [selectedClasseRedoublee, setSelectedClasseRedoublee] = useState(
		initialValues.classe_redoublement || null
	);
	const [selectedClasseInscription, setSelectedClasseInscription] =
		useState('');

	const handleChange = (field, value, feedbackMessage) => {
		// Update feedbackMessages
		setFeedbackMessages((prevMessages) => ({
			...prevMessages,
			[field]: feedbackMessage
		}));

		// Update formValues
		const newFormValues = {
			...formValues,
			[field]: value
		};
		setFormValues(newFormValues);

		// Call the onChange function passed in props with all the values
		props.onChange(newFormValues);
	};

	useEffect(() => {
		setFormValues({
			...initialValues,
			is_new_student: !!initialValues.ancienne_ecole,
			bulletin_notes_annee_precedente:
				initialValues.bulletin_notes_annee_precedente
					? {
							file: initialValues.bulletin_notes_annee_precedente.file,
							fileURL: initialValues.bulletin_notes_annee_precedente.fileURL
					  }
					: null
		});
		setSelectedStatut(initialValues.statut_eleve);
		setSelectedClasseRedoublee(initialValues.classe_redoublement);
		setSelectedClasseInscription(initialValues.salledeclasse);
		// Checkbox is checked if ancienne_ecole is not null or empty
		const isNewStudent = !!initialValues.ancienne_ecole;
		// Update formValues directly
		setFormValues((prevValues) => ({
			...prevValues,
			is_new_student: isNewStudent
		}));
		// Note: props.onChange is not called here
	}, [initialValues]);

	useEffect(() => {
		const fetchClassOptions = async () => {
			try {
				const classes = await SalledeclasseService.getClassOptions();
				setClasseOptions(classes);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchClassOptions();
	}, []);

	const STATUT_CHOICES = [
		{ value: 'parent_personnel', label: 'Parent Personnel' },
		{ value: 'parent_non_personnel', label: 'Parent Non Personnel' }
	];

	const CLASSE_CHOICES = classeOptions;

	return (
		<div>
			{/* Card */}
			<Card className="mb-3 ">
				<Card.Header className="border-bottom px-4 py-3">
					<h4 className="mb-0">Informations Scolaires</h4>
				</Card.Header>
				{/* Card body */}
				<Card.Body>
					{/* Statut eleve */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="statut_eleve">
							Statut éleve <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="statut_eleve"
							disabled
							isInvalid={!!feedbackMessages['statut_eleve']}
							value={selectedStatut}
							onChange={(e) => {
								const value = e.target.value;
								const feedbackMessage = value
									? ''
									: "Le statut de l'élève est requis.";
								handleChange('statut_eleve', value, feedbackMessage);
								setSelectedStatut(value);
							}}
						>
							<option value="">Sélectionner le statut de l'élève</option>
							{STATUT_CHOICES.map((choice, index) => (
								<option key={index} value={choice.value}>
									{choice.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['statut_eleve']}
						</Form.Control.Feedback>
					</Form.Group>

					{/* Ancienne école  */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="ancienne_ecole">Ancienne école</Form.Label>
						<Form.Control
							name="ancienne_ecole"
							disabled
							type="text"
							placeholder="Saisir le nom de l'ancienne école de l'élève"
							id="ancienne_ecole"
							value={formValues.ancienne_ecole || ''}
							onChange={(e) => {
								const value = e.target.value;
								handleChange('ancienne_ecole', value, '');
							}}
						/>
						<Form.Text className="text-muted">
							Laisser ce champ vide dans le cas où l'élève était dans cette
							école l'année précédente.
						</Form.Text>
					</Form.Group>

					{/* Bulletin notes annee precedente */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="bulletin_notes_annee_precedente">
							Bulletin notes année précédente
						</Form.Label>
						<Form.Control
							name="bulletin_notes_annee_precedente"
							disabled
							type="file"
							placeholder="Selectionner le bulletin de notes de l'année précedente"
							id="bulletin_notes_annee_precedente"
							accept="application/pdf, image/*"
							isInvalid={!!feedbackMessages['bulletin_notes_annee_precedente']}
							onChange={(e) => {
								const file = e.target.files[0];
								const isValidFile =
									file &&
									(file.type === 'application/pdf' ||
										file.type.startsWith('image/'));
								const feedbackMessage = isValidFile
									? ''
									: "Le fichier sélectionné n'est pas une image ou un fichier PDF.";
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									bulletin_notes_annee_precedente: feedbackMessage
								}));

								if (isValidFile) {
									// If the file is an image, create a blob URL to preview it
									const fileURL = file.type.startsWith('image/')
										? URL.createObjectURL(file)
										: null;
									handleChange(
										'bulletin_notes_annee_precedente',
										{ file, fileURL },
										feedbackMessage
									);
								}
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['bulletin_notes_annee_precedente']}
						</Form.Control.Feedback>
						<Form.Text className="text-muted">
							Laisser ce champ vide dans le cas où l'élève était dans cette
							école l'année précédente.
						</Form.Text>
					</Form.Group>

					{/* Classe redoublement */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="classe_redoublement">
							Classe redoublée
						</Form.Label>
						<Form.Select
							name="classe_redoublement"
							disabled
							isInvalid={!!feedbackMessages['classe_redoublement']}
							value={selectedClasseRedoublee || ''} // Use empty string as value if selectedClasseRedoublee is null
							onChange={(e) => {
								let value = e.target.value;
								if (value === '') {
									// Add this condition
									value = null;
								}
								handleChange('classe_redoublement', value, '');
								setSelectedClasseRedoublee(value);
							}}
						>
							<option value="">Selectionner la salle de classe</option>
							{CLASSE_CHOICES.map((choice, index) => (
								<option key={index} value={choice.value}>
									{choice.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['classe_redoublement']}
						</Form.Control.Feedback>
						<Form.Text className="text-muted">
							Ne rien selectionner si l'élève n'a redoublé aucune classe.
						</Form.Text>
					</Form.Group>

					{/* Nouvel élève ?  */}
					<Form.Group className="mb-3">
						<Form.Check
							name="is_new_student"
							disabled
							type="checkbox"
							id="is_new_student"
							label={"Nouvel élève dans l'établissement"}
							checked={formValues.is_new_student}
							onChange={(e) => {
								const value = e.target.checked;
								handleChange('is_new_student', value, '');

								// Mise à jour de is_new_student dans formValues
								setFormValues((prevValues) => ({
									...prevValues,
									is_new_student: value
								}));
							}}
						/>
						<Form.Text className="text-muted">
							Ne pas cocher cette case si l'élève était inscrit dans cet
							établissement l'année dernière.
						</Form.Text>
					</Form.Group>

					{/* Classe d'inscription */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="salledeclasse">
							Classe d'inscription
						</Form.Label>
						<Form.Select
							name="salledeclasse"
							disabled
							isInvalid={!!feedbackMessages['salledeclasse']}
							required
							value={selectedClasseInscription}
							onChange={(e) => {
								const value = e.target.value;
								const feedbackMessage = value
									? ''
									: "La classe d'inscripstion est requise.";
								handleChange('salledeclasse', value, feedbackMessage);
								setSelectedClasseInscription(value);
							}}
						>
							<option value="">Selectionner la salle de classe</option>
							{CLASSE_CHOICES.map((choice, index) => (
								<option key={index} value={choice.value}>
									{choice.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['salledeclasse']}
						</Form.Control.Feedback>
					</Form.Group>
				</Card.Body>
			</Card>

			{/* Button */}
			<div className="d-flex justify-content-between mb-22">
				{/* Button */}
				<Button variant="secondary" onClick={previous}>
					Précédent
				</Button>
			</div>
		</div>
	);
};
export default EditOldInfoScolaires;
